import dayjs from "../../../libraries/dayjs";

const liquidacionesStore = {
  namespaced: true,
  state: () => ({
    form: {
      codLiquidacion: "",
      fechaInicio: "",
      fechaFin: "",
      pasajero: "",
      codRegistro: "",
      agencia: "",
    },
    grupo: {
      agencia: null,
      moneda: null,
    },
    agencias: [],
    liquidaciones: [],
  }),
  mutations: {
    load(state, { agencias, liquidaciones, codLiquidacion, codRegistro }) {
      state.agencias = agencias;
      state.liquidaciones = liquidaciones;

      if (codLiquidacion) {
        state.form.codLiquidacion = codLiquidacion;
      }

      if (codRegistro) {
        state.form.codRegistro = codRegistro;
      }
    },
    actualizarGrupo(state, { agencia, moneda }) {
      state.grupo.agencia = agencia;
      state.grupo.moneda = moneda;
    },
    actualizarMarcados(state, liquidaciones) {
      state.liquidaciones = liquidaciones;
    },
  },
  getters: {
    liquidacionesFiltradas(state) {
      const codigoLiquidacion = String(state.form.codigoLiquidacion || "")
        .trim()
        .toLowerCase();
      const fechaInicio = state.form.fechaInicio || null;
      const fechaFin = state.form.fechaFin || null;
      const fechaInicioDjs = state.form.fechaInicio ? dayjs(state.form.fechaInicio, "YYYY-MM-DD") : null;
      const fechaFinDjs = state.form.fechaFin ? dayjs(state.form.fechaFin, "YYYY-MM-DD") : null;
      const pasajero = String(state.form.pasajero || "")
        .trim()
        .toLowerCase();
      const codRegistro = String(state.form.codRegistro || "")
        .trim()
        .toLowerCase();

      const agencia = state.form.agencia || "";

      return state.liquidaciones.filter((liquidacion) => {
        const inner = {
          codigoLiquidacion: String(liquidacion.codigo || "").toLowerCase(),
          fecha: liquidacion.fechaHora || null,
          fechaDjs: liquidacion.fechaDjs,
          agencia: liquidacion.agencia || null,
          pasajero: String(liquidacion.pasajero || "").toLowerCase(),
          codRegistro: String(liquidacion.codRegistro || "").toLowerCase(),
        };

        let match;

        match = !codigoLiquidacion ? true : inner.codigoLiquidacion.indexOf(codigoLiquidacion) !== -1;
        match = match && (!agencia ? true : inner.agencia == agencia);
        match = match && (!pasajero ? true : inner.pasajero.indexOf(pasajero) !== -1);
        match = match && (!codRegistro ? true : inner.codRegistro.indexOf(codRegistro) !== -1);

        if (fechaInicio && fechaFin) {
          match = match && (inner.fecha ? inner.fechaDjs >= fechaInicioDjs && inner.fechaDjs <= fechaFinDjs : false);
        } else if (fechaInicio && !fechaFin) {
          match = match && (inner.fecha ? inner.fecha == fechaInicio : false);
        }

        return match;
      });
    },
    marcados(state) {
      return state.liquidaciones.filter((item) => item.checked);
    },
    grupo: (state) => state.grupo,
  },
  actions: {
    check({ state, commit, getters }, { agencia, moneda, checked }) {
      if (!state.grupo.agencia) {
        commit("actualizarGrupo", { agencia, moneda });
        return;
      }

      if (getters.marcados.length == 0) {
        commit("actualizarGrupo", { agencia: null, moneda: null });
        commit(
          "actualizarMarcados",
          state.liquidaciones.map((item) => ({ ...item, checked: false }))
        );
        return;
      }
    },
  },
};

export default liquidacionesStore;
